import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Alert, AlertDescription, AlertTitle } from '../../components/ui/alert';
import { Loader2, Truck, FileText } from 'lucide-react';
import { fmtCurrency } from '../../lib/localeUtils';

export function ForecastPODialog({
  open, onOpenChange,
  selectedCount, totalValue,
  reorderDays, setReorderDays,
  onConfirm, loading,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="auto-po-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Truck className="h-5 w-5 text-primary" />
            Create Purchase Orders
          </DialogTitle>
          <DialogDescription>
            Auto-generate draft POs for {selectedCount} selected products, grouped by their most recent
            supplier with lowest cost.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Reorder Quantity (days of stock)</Label>
            <Input
              type="number"
              value={reorderDays}
              onChange={(e) => setReorderDays(parseInt(e.target.value) || 30)}
              min={7}
              max={90}
              data-testid="reorder-days-input"
            />
            <p className="text-xs text-muted-foreground">Order enough stock to cover this many days of demand</p>
          </div>
          <div className="bg-muted/50 rounded-lg p-3 space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Products Selected</span>
              <span className="font-medium">{selectedCount}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Stock Coverage</span>
              <span className="font-medium">{reorderDays} days</span>
            </div>
            {totalValue > 0 && (
              <div className="flex justify-between text-sm">
                <span className="text-muted-foreground">Estimated Value</span>
                <span className="font-medium">{fmtCurrency(totalValue)}</span>
              </div>
            )}
          </div>
          <Alert>
            <FileText className="h-4 w-4" />
            <AlertTitle>Draft PO</AlertTitle>
            <AlertDescription>
              POs will be created in draft status. Review and confirm them in the Purchases page before sending to suppliers.
            </AlertDescription>
          </Alert>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onConfirm} disabled={loading} className="gap-2" data-testid="confirm-create-po-btn">
            {loading
              ? <><Loader2 className="h-4 w-4 animate-spin" /> Creating...</>
              : <><Truck className="h-4 w-4" /> Create Draft PO</>
            }
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
